export const CURRENCY = "currency";
export const INITIAL = "initial";
export const DEFAULT_LOCATION_NAME = "Castellon";
export const DEFAULT_LOCATION_ID = "db4990de2a99aa47a56b87371a9d55cc";
export const DEFAULT_SAVE_BUTTON_HEADER = "Save";
export const DEFAULT_SAVE_AND_CALCULATE_BUTTON_HEADER = "Save and calculate";
export const DEFAULT_ADD_COST_PARAMETERS_HEADER = "Add cost parameters";
export const DEFAULT_EDIT_COST_PARAMETERS_HEADER = "Edit cost parameters";
export const DEFAULT_REVIEW_COST_PARAMETERS_HEADER = "Review cost parameters";
